"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GaslessOnboarding_chainId, _GaslessOnboarding_web3Auth, _GaslessOnboarding_provider, _GaslessOnboarding_loginConfig, _GaslessOnboarding_apiKey, _GaslessOnboarding_gaslessWallet, _GaslessOnboarding_gelatoRelay;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaslessOnboarding = exports.ErrorTypes = exports.GaslessOnboardingError = void 0;
// Web3Auth Dependencies
const modal_1 = require("@web3auth/modal");
const base_1 = require("@web3auth/base");
// Web3Auth Adapters
const openlogin_adapter_1 = require("@web3auth/openlogin-adapter");
const wallet_connect_v1_adapter_1 = require("@web3auth/wallet-connect-v1-adapter");
const metamask_adapter_1 = require("@web3auth/metamask-adapter");
// Gasless-Wallet
const gasless_wallet_1 = require("@gelatonetwork/gasless-wallet");
// Gelato Relay SDK
const relay_sdk_1 = require("@gelatonetwork/relay-sdk");
// Others
const ethers_1 = require("ethers");
const errors_1 = require("./errors");
Object.defineProperty(exports, "ErrorTypes", { enumerable: true, get: function () { return errors_1.ErrorTypes; } });
Object.defineProperty(exports, "GaslessOnboardingError", { enumerable: true, get: function () { return errors_1.GaslessOnboardingError; } });
const utils_1 = require("./utils");
const CLIENT_ID = "BEfbM81WrVzaSbV7oZTCt3B47ttTgFIdFkTD7VAvwAzm0My7fBGg--GGruerQ8NK2HvnmjHbeT2skbLUe187GF0";
class GaslessOnboarding {
    /**
     * @param {LoginConfig} loginConfig - The configuration for Web3Auth
     * @param {GaslessWalletConfig} gaslessWalletConfig - The configuration for the Gasless Wallet
     *
     */
    constructor(loginConfig, gaslessWalletConfig) {
        var _a, _b, _c;
        _GaslessOnboarding_chainId.set(this, void 0);
        _GaslessOnboarding_web3Auth.set(this, null);
        _GaslessOnboarding_provider.set(this, null);
        _GaslessOnboarding_loginConfig.set(this, void 0);
        _GaslessOnboarding_apiKey.set(this, void 0);
        _GaslessOnboarding_gaslessWallet.set(this, null);
        _GaslessOnboarding_gelatoRelay.set(this, void 0);
        __classPrivateFieldSet(this, _GaslessOnboarding_chainId, loginConfig.chain.id, "f");
        __classPrivateFieldSet(this, _GaslessOnboarding_loginConfig, {
            domains: loginConfig.domains,
            chain: {
                id: loginConfig.chain.id,
                rpcUrl: loginConfig.chain.rpcUrl,
            },
            ui: {
                theme: ((_a = loginConfig.ui) === null || _a === void 0 ? void 0 : _a.theme) || "light",
            },
            openLogin: {
                mfa: ((_b = loginConfig.openLogin) === null || _b === void 0 ? void 0 : _b.mfa) || undefined,
                redirectUrl: ((_c = loginConfig.openLogin) === null || _c === void 0 ? void 0 : _c.redirectUrl) || undefined,
            },
        }, "f");
        __classPrivateFieldSet(this, _GaslessOnboarding_gelatoRelay, new relay_sdk_1.GelatoRelay(), "f");
        __classPrivateFieldSet(this, _GaslessOnboarding_apiKey, gaslessWalletConfig.apiKey, "f");
    }
    /**
     * Initiates the GaslessOnboarding instance, required before invoking the other methods
     *
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const isNetworkSupported = yield __classPrivateFieldGet(this, _GaslessOnboarding_gelatoRelay, "f").isNetworkSupported(__classPrivateFieldGet(this, _GaslessOnboarding_chainId, "f"));
            if (!isNetworkSupported) {
                throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.UnsupportedNetwork, `Chain Id [${__classPrivateFieldGet(this, _GaslessOnboarding_chainId, "f")}]`);
            }
            const originData = __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").domains.length
                ? yield (0, utils_1.getSignatures)(__classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").domains)
                : {};
            const web3Auth = new modal_1.Web3Auth({
                clientId: CLIENT_ID,
                chainConfig: {
                    chainNamespace: base_1.CHAIN_NAMESPACES.EIP155,
                    chainId: ethers_1.ethers.utils.hexValue(__classPrivateFieldGet(this, _GaslessOnboarding_chainId, "f")),
                    rpcTarget: __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").chain.rpcUrl,
                },
                uiConfig: {
                    appName: "Gelato",
                    theme: __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").ui.theme,
                    loginMethodsOrder: ["google"],
                    defaultLanguage: "en",
                },
                web3AuthNetwork: "cyan",
            });
            const loginSettings = __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").openLogin.redirectUrl
                ? {
                    mfaLevel: __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").openLogin.mfa,
                    redirectUrl: __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").openLogin.redirectUrl,
                }
                : { mfaLevel: __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").openLogin.mfa };
            const openloginAdapter = new openlogin_adapter_1.OpenloginAdapter({
                loginSettings,
                adapterSettings: {
                    uxMode: "redirect",
                    whiteLabel: {
                        name: "Gelato",
                        defaultLanguage: "en",
                        dark: __classPrivateFieldGet(this, _GaslessOnboarding_loginConfig, "f").ui.theme === "dark" ? true : false,
                        theme: { primary: "#b45f63" },
                    },
                    originData,
                },
            });
            const walletConnectV1Adapter = new wallet_connect_v1_adapter_1.WalletConnectV1Adapter({
                clientId: CLIENT_ID,
            });
            const metamaskAdapter = new metamask_adapter_1.MetamaskAdapter({
                clientId: CLIENT_ID,
            });
            web3Auth.configureAdapter(openloginAdapter);
            web3Auth.configureAdapter(walletConnectV1Adapter);
            web3Auth.configureAdapter(metamaskAdapter);
            yield web3Auth.initModal();
            if (web3Auth.provider) {
                __classPrivateFieldSet(this, _GaslessOnboarding_provider, web3Auth.provider, "f");
                yield this._initializeGaslessWallet();
            }
            __classPrivateFieldSet(this, _GaslessOnboarding_web3Auth, web3Auth, "f");
        });
    }
    /**
     * @returns {SafeEventEmitterProvider | null} The SafeEventEmitterProvider object or null if the user is not logged in yet
     *
     */
    getProvider() {
        return __classPrivateFieldGet(this, _GaslessOnboarding_provider, "f");
    }
    /**
     * @returns {Promise<Partial<UserInfo>>} The user information if logged in with social media accounts
     *
     */
    getUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f")) {
                throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.OnboardingNotInitiated);
            }
            return yield __classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f").getUserInfo();
        });
    }
    /**
     * Pops up the login modal
     * @returns {Promise<SafeEventEmitterProvider>} The SafeEventEmitterProvider object
     *
     */
    login() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f")) {
                throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.OnboardingNotInitiated);
            }
            const provider = yield __classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f").connect();
            if (!provider) {
                throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.LoginFailed);
            }
            __classPrivateFieldSet(this, _GaslessOnboarding_provider, provider, "f");
            yield this._initializeGaslessWallet();
            return provider;
        });
    }
    /**
     * Logs the user out, clears the cache
     *
     */
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f")) {
                throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.OnboardingNotInitiated);
            }
            yield __classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f").logout();
            __classPrivateFieldGet(this, _GaslessOnboarding_web3Auth, "f").clearCache();
            __classPrivateFieldSet(this, _GaslessOnboarding_provider, null, "f");
        });
    }
    /**
     * @returns {GaslessWallet} The GaslessWallet of the user
     *
     */
    getGaslessWallet() {
        if (!__classPrivateFieldGet(this, _GaslessOnboarding_provider, "f") || !__classPrivateFieldGet(this, _GaslessOnboarding_gaslessWallet, "f")) {
            throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.NotLoggedIn);
        }
        return __classPrivateFieldGet(this, _GaslessOnboarding_gaslessWallet, "f");
    }
    _initializeGaslessWallet() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!__classPrivateFieldGet(this, _GaslessOnboarding_provider, "f")) {
                throw new errors_1.GaslessOnboardingError(errors_1.ErrorTypes.NotLoggedIn);
            }
            const gaslessWallet = new gasless_wallet_1.GaslessWallet(__classPrivateFieldGet(this, _GaslessOnboarding_provider, "f"), {
                apiKey: __classPrivateFieldGet(this, _GaslessOnboarding_apiKey, "f"),
            });
            yield gaslessWallet.init();
            __classPrivateFieldSet(this, _GaslessOnboarding_gaslessWallet, gaslessWallet, "f");
        });
    }
}
exports.GaslessOnboarding = GaslessOnboarding;
_GaslessOnboarding_chainId = new WeakMap(), _GaslessOnboarding_web3Auth = new WeakMap(), _GaslessOnboarding_provider = new WeakMap(), _GaslessOnboarding_loginConfig = new WeakMap(), _GaslessOnboarding_apiKey = new WeakMap(), _GaslessOnboarding_gaslessWallet = new WeakMap(), _GaslessOnboarding_gelatoRelay = new WeakMap();
